import { Contract } from "../model";

export class ContractUpdateCommand{
    contractView: Contract

    constructor(contract:Contract) {
        
        this.contractView = contract;
    }
}